import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

const editModalDrivingSchoolsSlice = createSlice({
  name: "editModalDrivingSchools",
  initialState,
  reducers: {
    openModal: (state, action) => {
      const itemId = action.payload;
      state[itemId] = true;
    },
    closeModal: (state, action) => {
      const itemId = action.payload;
      state[itemId] = false;
    },
  },
});

export const { openModal, closeModal } = editModalDrivingSchoolsSlice.actions;

export default editModalDrivingSchoolsSlice.reducer;
